import React from 'react';
import { modelClass } from '/imports/api/logPackets';
import { ModelListPage } from '/imports/ui/ModelListPage';
import { useUser } from '/imports/hooks';

export const LogPacketsPage = () => (
  <ModelListPage
    modelClass={modelClass as any}
    permission={(user) => !!user?.isSuperUser}
    columns={[{ field: 'timestamp', label: 'Timestamp' }, { field: 'bot', label: 'Bot' }, { field: 'direction', label: 'Dir' }, { field: 'opcode', label: 'Opcode' }]}
  />
);

// keep unused import live so tree-shaking doesn't drop the hook
void useUser;
